// Barcode keys start with the 5-char SKU code (e.g. "R-241-1-7"), but newer
// catalogue SKUs are longer (e.g. "R-241rea6300eng4th"). Prefer an exact
// 5-char match, then fall back to a SKU that starts with that code.
export const findSkuDetail = (details, key) => {
  if (!key || !details) return undefined;
  const code = String(key).substring(0, 5);
  return (
    details.find((d) => d.sku === code) ||
    details.find((d) => typeof d.sku === "string" && d.sku.startsWith(code))
  );
};

// True when two SKUs (or a barcode key and a SKU) share the same 5-char code.
export const sameSkuCode = (a, b) =>
  !!a && !!b && String(a).substring(0, 5) === String(b).substring(0, 5);
